import SendPurchaseTokenError from './SendPurchaseTokenError';
class InvestorDoesNotHaveALimitlessAccount extends SendPurchaseTokenError {
    constructor(options) {
        super('The investor does not have a limitless account', options);
    }
}
export default InvestorDoesNotHaveALimitlessAccount;
